import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/inventory/procurement/";
export function getPendingReceivePo(warehouseID, itemType = "I") {
  return http.get(
    apiEndpoint +
      "purchase-order/pending-receive-po/" +
      warehouseID +
      "/" +
      itemType
  );
}
export function getPendingReceivePoItems(poID, itemType = "I") {
  return http.get(
    apiEndpoint +
      "purchase-order/pending-receive-po-items/" +
      poID +
      "/" +
      itemType
  );
}

export function savePurchaseOrder(purchaseOrder) {
  if (purchaseOrder.ID === 0) {
    return http.post(apiEndpoint + "purchase-order", purchaseOrder);
  } else {
    return http.put(apiEndpoint + "purchase-order", purchaseOrder);
  }
}

export function cancelPurchaseOrder(poID = 0) {
  return http.delete(apiEndpoint + "purchase-order/" + poID);
}

export function getPurchaseOrders() {
  return http.get(apiEndpoint + "purchase-order/purchase-orders");
}
export function getLazyPurchaseOrders(
  first = 0,
  rows = 5,
  sortField = "purchaseOrderCode",
  sortOrder = 1
) {
  return http.get(
    apiEndpoint +
      `purchase-order/purchase-orders/${first}/${rows}/${sortField}/${sortOrder}`
  );
}
export function getPurchaseOrderItems(poID = 0, itemType = "all") {
  return http.get(
    apiEndpoint + "purchase-order/purchase-order-items/" + poID + "/" + itemType
  );
}
export function getPurchaseOrder(purchaseOrderID = 0, passAuth = "false") {
  return http.get(
    apiEndpoint +
      "purchase-order/purchase-order/" +
      purchaseOrderID +
      "/" +
      passAuth
  );
}
export function savePurchaseRequests(purchaseRequests) {
  return http.post(apiEndpoint + "purchase-request", purchaseRequests);
}
export function getAllPurchaseRequests() {
  return http.get(apiEndpoint + `purchase-request/all`);
}
export function getPurchaseRequests(
  itemRequestID = 0,
  warehouseID = 0,
  salesOrderID = 0,
  statusID = 0
) {
  return http.get(
    apiEndpoint +
      `purchase-request/${itemRequestID}/${warehouseID}/${salesOrderID}/${statusID}`
  );
}
export function cancelPurchaseRequest(purchaseRequestID) {
  return http.delete(apiEndpoint + "purchase-request/" + purchaseRequestID);
}
export function changePurchaseRequestStatus(purchaseRequestID, statusId) {
  return http.put(
    apiEndpoint + `purchase-request/${purchaseRequestID}/${statusId}`
  );
}

export function getPurchaseRequestDetail(purchaseRequestID = 0) {
  return http.get(
    apiEndpoint +
      "purchase-request/purchase-request-detail/" +
      purchaseRequestID
  );
}

export function getPurchaseRequestItems(
  purchaseRequestHeadID = 0,
  warehouseID = 0
) {
  return http.get(
    apiEndpoint +
      `purchase-request/purchase-request-items/${purchaseRequestHeadID}/${warehouseID}`
  );
}

export function getRfqList() {
  return http.get(apiEndpoint + "rfq/rfq-list");
}

export function getRfqDetail(rfqID = 0) {
  return http.get(apiEndpoint + "rfq/rfq-detail/" + rfqID);
}

export function cancelRfq(rfqID = 0) {
  return http.delete(apiEndpoint + "rfq/rfq/" + rfqID);
}

export function saveRfq(rfq = { ID: 0 }) {
  return http.post(apiEndpoint + "rfq", rfq);
}

export function saveRfqVendorQuote(vendor = { ID: 0 }) {
  return http.post(apiEndpoint + "rfq/vendor-quote", vendor);
}

export function getRfqVendorQuote(rfqVendorID = 0) {
  return http.get(apiEndpoint + "rfq/vendor-quote/" + rfqVendorID);
}

export function deleteRfqVendorQuote(rfqVendorID = 0) {
  return http.delete(apiEndpoint + "rfq/vendor-quote/" + rfqVendorID);
}

export function updateRfqVendorStatus(rfqVendorID = 0, statusID = 0) {
  return http.put(
    apiEndpoint + "rfq/vendor-quote-status/" + rfqVendorID + "/" + statusID
  );
}

export function convertVendorQuotePO(convertPo) {
  return http.post(apiEndpoint + "rfq/convert-quote-po", convertPo);
}

export function getContracts() {
  return http.get(apiEndpoint + "contract/contract-list");
}

export function getContract(contractID = 0) {
  return http.get(apiEndpoint + "contract/contract-detail/" + contractID);
}

export function saveContract(contract) {
  return http.post(apiEndpoint + "contract", contract);
}

export function getContractPurchaseOrders(contractID = 0) {
  return http.get(
    apiEndpoint + "contract/contract-purchase-orders/" + contractID
  );
}

export function getContractItems(contractID = 0) {
  return http.get(apiEndpoint + "contract/contract-items/" + contractID);
}

export function deleteContract(contractID = 0) {
  return http.delete(apiEndpoint + "contract/contract/" + contractID);
}
